export const sendButton = () => `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="inherit" xmlns="http://www.w3.org/2000/svg">
        <path 
            stroke="inherit"
            d="M17.8332 6.16663L11.4165 12.5833" 
            stroke-width="1.2" 
            stroke-linecap="round" 
            stroke-linejoin="round"
        />
        <path 
            stroke="inherit"
            d="M17.8332 6.16663L13.7498 17.8333L11.4165 12.5833L6.1665 10.25L17.8332 6.16663Z"
            stroke-width="1.2" 
            stroke-linecap="round" 
            stroke-linejoin="round"
        />
    </svg>
    `;
